/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Chain entity
 * @export
 * @interface IntegrationChainEntity
 */
export interface IntegrationChainEntity {
    /**
     * 
     * @type {string}
     * @memberof IntegrationChainEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationChainEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationChainEntity
     */
    chainName?: string;
    /**
     * 
     * @type {string}
     * @memberof IntegrationChainEntity
     */
    chainSteps?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationChainEntity
     */
    enabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof IntegrationChainEntity
     */
    lastExecutionId?: string;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationChainEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof IntegrationChainEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof IntegrationChainEntity
     */
    createdBy?: string;
}

/**
 * Check if a given object implements the IntegrationChainEntity interface.
 */
export function instanceOfIntegrationChainEntity(value: object): value is IntegrationChainEntity {
    return true;
}

export function IntegrationChainEntityFromJSON(json: any): IntegrationChainEntity {
    return IntegrationChainEntityFromJSONTyped(json, false);
}

export function IntegrationChainEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationChainEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'chainName': json['chainName'] == null ? undefined : json['chainName'],
        'chainSteps': json['chainSteps'] == null ? undefined : json['chainSteps'],
        'enabled': json['enabled'] == null ? undefined : json['enabled'],
        'lastExecutionId': json['lastExecutionId'] == null ? undefined : json['lastExecutionId'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
    };
}

export function IntegrationChainEntityToJSON(json: any): IntegrationChainEntity {
    return IntegrationChainEntityToJSONTyped(json, false);
}

export function IntegrationChainEntityToJSONTyped(value?: IntegrationChainEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'chainName': value['chainName'],
        'chainSteps': value['chainSteps'],
        'enabled': value['enabled'],
        'lastExecutionId': value['lastExecutionId'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
    };
}

